(function () {'use strict';}());
angular.module("app").directive('useView', function($document,$timeout) {
    return {
      restrict: 'A',
      transclude:true,
      scope:{tip:"&",question:"=",index:"="},
      template: "<div ng-bind-html='useDisplay' ng-class=\"['useDisplay',$parent.$parent.currentUseScreenIndex == index ? 'on':'off']\"></div> <button ng-if='$parent.$parent.currentUseScreenIndex == index' ng-click='advanceScreen()'>Continue</button><style> html div#app-container div#assessment div.assessmentScreen div.use div#useView{{question.id}} li:nth-child({{bullet}}) {display: block;}</style>",

      link:function($scope,element,attr)
      {
        var trace = angular.trace;
        var parent = $scope.$parent.$parent;
        $scope.currentScreenIndex = 0;
        $timeout(initialize,0);

       // $scope.$parent.$parent.$on("assessmentChange",initialize);

        $scope.advanceScreen = function(){
        	if(parent.currentUseScreenIndex === 0) parent.currentUseScreenIndex ++;
        	else 
          {
            parent.resetAssessmentMenu();
            parent.setCurrentPage(parent.PAGE_SHARE);
          }
        };	

        function initialize()
        {
        	var question = $scope.question;
        	$scope.useDisplay = $scope.tip({question:$scope.question,score:getLabel($scope.question)});

        	var length = angular.element($scope.useDisplay).find("li").length;
        	$scope.bullet = Math.floor(Math.random() * length)+1;
        }
        function getLabel(question)
        {
        	var response = question.userResponse ? parseInt(question.userResponse) : 0;
        	if(response > 2) response = 2;
        	if(response === 0) return "low";
        	if(response === 1) return "moderate";
        	return "high";
        }
      }  
    };
  });